export default "__VITE_ASSET__d61e06bf__"